<template>
  <section class="flex max-w-full w-screen min-h-screen">
    <portal-target name="dropdown" slim class="teste" />
    <div class="container_navigation w-80 min-h-screen fixed p-5 pb-5">
      <main-menu />
    </div>

    <div class="container_content w-full min-h-screen p-10">
      <slot />
    </div>
  </section>
</template>

<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from './MainMenu'

export default {
  components: {
    Dropdown,
    Icon,
    MainMenu,
  },
}
</script>

<style scoped>
section {
}

.container_navigation {
  min-width: 300px;
  max-width: 350px;
  height: 100vh;
}

.container_content {
  width: 100vw;
  max-width: 100%;
  padding-left: 340px;
  overflow-x: hidden;
}

@media screen and (max-width: 1000px) {
  section {
    display: flex;
    flex-direction: column;
  }

  .container_navigation {
    position: static;
    width: 100vw;
    max-width: 100%;
    min-height: 90px;
    height: 90px;
    background-color: #1e293b;
  }

  .container_content {
    width: 100vw;
    max-width: 100%;
    padding-left: 340px;
    overflow-x: hidden;
  }
}
</style>
